export const ESI_INITIAL_STATE = {
    employee_contribution: "",
    employer_contribution: "",
    decuction_cycle: "",
    state_id: 2
}

